module.exports = __webpack_public_path__ + "img/livepen-kid1.7b765bef.png";